/*
  账号相关api接口
 */
import request from './request';
import md5 from 'js-md5';

export const accountApi = {
  /**
   * 登录
   */
  login (data) {
    let _data = {
      ...data,
    };
    _data.password = md5(data.password);
    return request({
      url: '/auth/login',
      method: 'post',
      data: _data,
    });
  },
  /**
   * 注册
   */
  regist (data, geetestData) {
    let _data = {
      ...data,
      registerType: 'EMAIL',
    };
    _data.password = md5(data.password);
    if (_data.sign) {
      delete _data.sign;
    }
    return request({
      url: '/user/register',
      method: 'post',
      data: _data,
      // headers: {
      //   ...geetestData,
      //   sign: data.sign,
      // },
    });
  },

  /**
   * 找回密码、忘记密码
   *  data => {
        "countryCode": "",// 如果是通过手机找回则需要，否则可以不传递
        "email": "",
        "ga_code": "", // 后端未校验谷歌验证码，可以不填
        "identityNo": "",
        "mobile": "", // 如果是通过手机找回则需要，否则可以不传递
        "password": "",
        "validateCode": "",
   *  }
   *  // 极验数据
   *  geetestData => {
   *    geetest_challenge,
        geetest_validate,
        geetest_seccode,
   *  }
   */
  resetPwd (_data) {
    let data = {
      ..._data,
    };
    data.password = md5(data.password);
    return request({
      url: '/user/forget/pwd',
      method: 'put',
      data,
    });
  },
  /**
   * 校验邮箱是否被注册
   */
  checkEmail (email) {
    return request({
      url: '/api/u/user/security/check/email',
      params: {
        email: email,
      },
      method: 'get',
    });
  },
  /**
   * 校验手机号是否被注册
   */
  checkTel (phoneNo, phoneCode) {
    return request({
      url: '/api/u/user/security/check/phoneNo',
      params: {
        phoneNo,
        phoneCode,
      },
      method: 'get',
    });
  },

/**
 * 绑定手机号
 */
  bindTel (data) {
    return request({
      url: '/api/u/user/security/bindingPhone',
      data,
      method: 'post',
    });
  },
  /**
   * 找回密码、忘记密码
   *  data => {
        "countryCode": "",// 如果是通过手机找回则需要，否则可以不传递
        "email": "",
        "ga_code": "", // 后端未校验谷歌验证码，可以不填
        "identityNo": "",
        "mobile": "", // 如果是通过手机找回则需要，否则可以不传递
        "password": "",
        "validateCode": "",
   *  }
   *  // 极验数据
   *  geetestData => {
   *    geetest_challenge,
        geetest_validate,
        geetest_seccode,
   *  }
   */
  forgetPwd (data, geetestData) {
    data.password = md5(data.password);
    delete data.sign;
    return request({
      url: '/api/u/user/security/forgotPassword',
      method: 'post',
      headers: geetestData,
      data,
    });
  },
  /**
   *退出登录，无效接口。调用也无效
   */
  logout () {
    return request({
      url: '/api/u/logout',
      method: 'get',
    });
  },
};
